import './freepage.css';
function FreePage({ image, contentP, contentSpan, btn, btnValue }) {
  return (
    <div className="free-page w-100 py-5 ">
      <div className='content d-flex flex-column align-items-center'>
        <div className='img'>
          {image}
        </div>
        <p>{contentP}</p>
        {contentSpan && 
          <span>{contentSpan}</span>
      }
      </div>
      <div className='d-flex justify-content-center' style={{ marginTop: '0px', marginBottom: '18px ' }}>
        <button className='btn' onClick={() => btnValue(true)}>{btn}</button>
      </ div>
    </div>
  )
}
export default FreePage;